// extracted by mini-css-extract-plugin
module.exports = {"commentEditor":"comment_editor_commentEditor__ZCK16"};